import React, { useContext, useRef, useState } from "react";

import useLog from "../hooks/useLog";

import { Loader } from "../components/Loader";
import { SlidePopup, WithPopup } from "../components/WithPopup/TextCopyQR";
import { Alert, ProgressBar } from "react-bootstrap";
import { confirmPopup } from "../components/confirmPopup";
import { UserContext } from "../Contexts/UserContext/UserContext";
import GlobalErrorContext from "../Contexts/GlobalErrorContext";
import { translateErrorToJSXMessage, isNetworkErrorString } from "../translateErrorToJSXMessage";
import RunContext from "../Contexts/RunContext";
import RuncraftContext from "../Contexts/RuncraftContext";



export const SyncBlockchainPopup = (props) => {
    const function_id = "SyncBlockchainPopup(): "
    // const classname = function_id
    const log = useLog(function_id)

    const userContext = useContext(UserContext)

    const runContext = useContext(RunContext)
    const run = runContext.run

    // display global errors
    const globalErrorContext = useContext(GlobalErrorContext)
    var globalError_jsx = null
    if (globalErrorContext.globalError) {
        const isNetworkError = isNetworkErrorString(globalErrorContext.globalError)
        globalError_jsx =
            <WithPopup
                fullWidth transparent
                forceShow={true}
                buttonText={isNetworkError ? "Retry" : "Continue"}
                popupcontent={
                    translateErrorToJSXMessage(globalErrorContext.globalError)
                }
                closePopupCallback={isNetworkError
                    ? () => { userContext.resetGlobalError(); userContext.reload_wallet() }
                    : userContext.resetGlobalError
                }
            />
    }

    // progress bar

    // loading transactions should only be like 1/third in the middle
    // first third = setup stuff (creating run, caches, runcraft)
    // second third = loading transactions
    // last third = wallet sync (solde_delphe for now)

    const [finished, set_finished] = useState(false)

    const update_progress_bar = () => {
        update_progress_bar_setup()
        // update_progress_bar_history()
        update_progress_bar_walletSync()
    }

    // setup loading progress (run, bsv & caches setup)

    /*
    // TODO add runcraft loading
    const runcraftContext = useContext(RuncraftContext)
    const Runcraft = runcraftContext.Runcraft
    // // ref is needed for setTimeout to always have the latest value
    // // but beware: a ref changing value doesn’t trigger a re-render
    const RuncraftRef = useRef()
    RuncraftRef.current = Runcraft
*/

    const [percent_loadBSV, set_percent_loadBSV] = useState(0)
    const update_progress_bar_setup = () => {
        let newval = (userContext.balance_bsv != null ? 100 : 0)

        log("update_progress_bar_setup: newval=", newval, ", userContext.balance_bsv=", userContext.balance_bsv)

        const need_update = (newval != percent_loadBSV)
        if (need_update) set_percent_loadBSV(newval)
        return need_update
    }

    /* // 19.12.2022 decided to remove the history loading from the progress bar popup
    // history loading progress

    const [percent_history, set_percent_history] = useState(0)
    const [nbloaded, set_nbloaded] = useState(null)
    const [historysize, set_historysize] = useState(null)

    const update_progress_bar_history = () => {
        // using a get function is a great way to not have to deal with the issue of "context doesn't update in setTimeout, need to use a ref"
        var history_loading_progress = userContext.get_history_loading_progress()
        var _historysize = history_loading_progress.size
        var _nbloaded = history_loading_progress.nbloaded

        log("update_progress_bar_history:", _nbloaded, "/", _historysize)

        // important to test if update really needed, or to include them to need_update (not done for now)
        if (_nbloaded != nbloaded) set_nbloaded(_nbloaded)
        if (_historysize != historysize) set_historysize(_historysize)

        // let's avoid having percent=NaN
        _nbloaded = _nbloaded || 0
        if (_historysize === 0) {
            // 0 = no transactions, so we are already at 100%
            _nbloaded = 100
            _historysize = 100
        }
        else {
            _historysize = _historysize || 100
        }

        let percent = parseInt(_nbloaded / _historysize * 100)

        const need_update = (percent != percent_history)
        if (need_update) set_percent_history(percent)
        return need_update
    }
    */

    // wallet sync progress

    const tokenID = userContext.get_selected_coin_props().tokenid

    const [percent_loadTokens, set_percent_loadTokens] = useState(0)
    const update_progress_bar_walletSync = () => {
        const balance_delphe = userContext.tokens_balance[tokenID]
        let newval = (balance_delphe != null ? 100 : 0)  // TODO find a more precise way ?
        const need_update = (newval != percent_loadTokens)
        if (need_update) set_percent_loadTokens(newval)
        return need_update
    }

    // let's retrieve the time spent by each part of the loading
    const [start_time, set_start_time] = useState(null)
    const [time_spent_loadBSV, set_time_spent_loadBSV] = useState(null)
    // const [time_spent_history, set_time_spent_history] = useState(null)
    const [time_spent_loadTokens, set_time_spent_loadTokens] = useState(null)
    if (!start_time) set_start_time(Date.now())
    if (percent_loadBSV >= 100 && !time_spent_loadBSV) set_time_spent_loadBSV(Date.now() - start_time)
    // if (percent_history >= 100 && !time_spent_history) set_time_spent_history(Date.now() - start_time)
    if (percent_loadTokens >= 100 && !time_spent_loadTokens) set_time_spent_loadTokens(Date.now() - start_time)

    log("update_progress_bar:",
        "\n percent_loadBSV:", percent_loadBSV, "%",
        // "\n percent_history:", percent_history, "%",
        "\n percent_loadTokens:", percent_loadTokens, "%",
        "\n ---",
        "\n time_spent_loadBSV:", parseInt(time_spent_loadBSV / 1000), "secs",
        // "\n time_spent_history:", parseInt(time_spent_history/1000), "secs",
        "\n time_spent_loadTokens:", parseInt(time_spent_loadTokens / 1000), "secs",
    )

    // var total_percent = (percent_loadBSV + percent_history + percent_loadTokens) / 3 + 1
    var total_percent = (percent_loadBSV * 1 / 3 + percent_loadTokens * 2 / 3) + 1
    if (total_percent < 5) total_percent = 5 // min value for a nice display
    else if (total_percent > 100) total_percent = 100
    total_percent = parseInt(total_percent) // display as int
    if (total_percent < 100) {
        // wait a bit to not freeze display & then reupdate
        setTimeout(() => {
            update_progress_bar()
        }, 1000)
    }

    // force ignore hidden button
    const [force_ignore, set_force_ignore] = useState(false)
    const [popup_lock, set_popup_lock] = useState(false)
    async function forceIgnore() {
        if (popup_lock) return
        set_popup_lock(true)
        let confirm = await confirmPopup(
            "Ignorer la synchronisation, même si le wallet pourra être freezé un certain temps ?",
            "ignorer"
        )
        log("confirm ignore =", confirm)
        set_popup_lock(false)
        if (!confirm) return
        else set_force_ignore(true)
    }
    if (force_ignore) return null

    if (total_percent >= 100 && !finished) {

        // wait 2 sec and then close the popup
        setTimeout(() => {
            set_finished(true)
            /*
            // TODO add runcraft loading
            // now that the user can see his wallet, ask Runcraft to sync everything asynchronously
            log("calling Runcraft.syncAll()...")
            RuncraftRef.current.syncAll(run)
            */
        }, 1700);
    }
    if (finished) return null

    return (
        <SlidePopup fullWidth hideButton="true">

            {globalError_jsx}

            <Alert variant="info">
                Pensez à noter et garder votre phrase clé secrète dans un endroit sécurisé.
            </Alert>

            <div style={{ height: "10vh" }} />

            <h1>
                Synchronisation avec la Blockchain <br /><br />
                <Loader largeIcon noMess />
            </h1><br />

            <span style={{ position: "relative" }}>
                <ProgressBar
                    style={{ height: "25px", fontSize: "15px" }}
                    variant="success" now={total_percent || 0}
                    label={total_percent + " %"}
                    animated
                />
            </span><br /><br />

            <Alert variant="warning" style={{ marginTop: "10%" }}>
                A l'ouverture, votre portefeuille doit se synchroniser avec la blockchain.
                Ce processus est plus rapide si vous l'ouvrez souvent, sinon il peut durer jusqu'à quelques minutes.
                Nous travaillons à rendre ce processus plus rapide, merci pour votre patience.
            </Alert>

            <span style={{ color: "#656565", cursor: "pointer" }} onClick={forceIgnore}>
                Ignorer la synchronisation
            </span>

        </SlidePopup>
    )
}
